import { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { getBaseURL, getS3ReplaceBucketKey } from '../config/env-config';
import { getBizCode } from '../services/business-details-service';
import logger from '../services/logger';

const DynamicTitleAndFavicon = () => {
    const bizCode = useMemo(() => getBizCode(), []); // Memoize bizCode

    const { biz } = useSelector((state) => {
        return {
            biz: state?.biz?.bizData,
        };
    });

    const baseUrl = useMemo(() => getBaseURL()?.replace("/bapi", ""), []); // Memoize baseUrl

    const bizLogo = useMemo(() => {
        return bizCode !== '' && bizCode !== null && bizCode !== undefined ? biz?.logoUrl?.replace(`https://s3-ap-southeast-1.amazonaws.com/${getS3ReplaceBucketKey()}`, `${baseUrl}/content`) : '';
    }, [biz, bizCode, baseUrl]); // Memoize bizLogo

    const bizTitle = useMemo(() => {
        logger.info("BIZ TITLE ", biz?.title);
        return bizCode !== '' && bizCode !== null && bizCode !== undefined && biz?.title !== undefined ? biz?.title : 'Hooper';
    }, [biz, bizCode]); // Memoize bizLogo

    useEffect(() => {
        // Set document title
        document.title = bizTitle;

        // Update the favicon
        const faviconLink = document.querySelector("link[rel*='icon']") || document.createElement('link');
        faviconLink.type = 'image/x-icon';
        faviconLink.rel = 'shortcut icon';
        faviconLink.href = bizLogo;
        document.head.appendChild(faviconLink);

        // Cleanup
        return () => {
            document.head.removeChild(faviconLink);
        };
    }, [bizLogo, bizCode, bizTitle]); // Run once on component mount or when bizLogo or bizCode changes

    return null; // This component doesn't render anything
};

export default DynamicTitleAndFavicon;
